import { render, staticRenderFns } from "./DocumentDisplayer.vue?vue&type=template&id=52fa5b3c"
import script from "./DocumentDisplayer.vue?vue&type=script&lang=ts"
export * from "./DocumentDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports